module.exports = __webpack_public_path__ + "static/media/ic-why-massage.e7c14077.svg";